/* eslint-disable no-invalid-this */
import React from 'react';
import TextInput from './TextInput';
import CopyButton from './CopyButton';

type CopyInputProps = {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder: string;
  className: string;
  tabIndex: number;
};

const CopyInput = ({ value, onChange, placeholder, className, tabIndex }: CopyInputProps) => {
  return (
    <div className={`relative ${className}`}>
      <div className="flex justify-between w-full">
        <TextInput
          name="search"
          value={value}
          onChange={onChange}
          extraClass={'w-full'}
          inputClassName={'highed-field-input shadow-none font-bold text-xs'}
          placeholder={placeholder}
          readOnly={true}
          tabIndex={tabIndex}
        />
        {value && <CopyButton value={value} tabIndex={tabIndex} />}
      </div>
    </div>
  );
};

export default CopyInput;
